// extracted by mini-css-extract-plugin
export var container = "styles-module__container___jehPm";
export var header = "styles-module__header___duQLN";
export var sliderContainer = "styles-module__sliderContainer___If9wc";
export var mobileSliderContainer = "styles-module__mobileSliderContainer___XfbhZ";
export var dotContainer = "styles-module__dotContainer___D60fW";
export var dot = "styles-module__dot___r7JZm";
export var active = "styles-module__active___sTfct";